import React from 'react'
import { DragDropContainer } from 'components/library'
import './DraggableCard.css'

const DraggableCard = props => (
  <div className={`has-status-${props.data.status === 1 ? 'done' : 'active'} ${props.data.status === 2 ? 'is-wrong' : ''}`}>
    <DragDropContainer dragData={props.data} onDrop={props.onDrop}>
      <div className="Draggable-card">{props.data.label}{props.count && <span className="Draggable-card-number">{props.data.id}</span>}</div>
    </DragDropContainer>
  </div>
)

export default DraggableCard 


// WEBPACK FOOTER //
// ./src/components/library/dnd/DraggableCard.js